import React from "react";
import { useNavigate } from "react-router-dom";

const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>Access Denied</h1>
      <p>You are not authorized to view this page.</p>
    </div>
  );
};

export default NotAuthorized;